import React, { useEffect, useState } from 'react'
import '../../styles/toggle-switch.css'

function ToggleSwitch({ label, name, onChange, checked, disabled }) {
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const handleToggle = (e) => {
    if (disabled) return
    setIsChecked(!isChecked)
    onChange(e)
  }

  return (
    <div>
      <div className={`toggle-switch-container ${disabled ? 'disabled' : ''}`}>
        <label className="toggle-switch">
          <input
            id={name}
            name={name}
            type="checkbox"
            checked={isChecked}
            onChange={handleToggle}
            disabled={disabled}
          />
          <span className="slider round"></span>
        </label>
        <label style={{ paddingLeft: '.25em', opacity: disabled ? 0.5 : 1 }} htmlFor={name}>
          {label}
        </label>
      </div>
    </div>
  )
}

export default ToggleSwitch
